import { PatientPhysicalStatus } from "requests";

// Select does not work properly with `0` as number in value.
export const DENTAL_SCORE_OPTIONS = [
  {
    value: "0",
    label:
      "Dental score 0 -  The teeth show no evidence of abnormal wear, tartar accumulation or calculi accumulation. No gingivitis is present."
  },
  {
    value: "1",
    label:
      "Dental score 1 - The teeth show evidence of normal wear, calculus accumulation is mild. Mild gingivitis is present."
  },
  {
    value: "2",
    label:
      "Dental score 2 - The teeth show evidence of wear, moderate calculus accumulation is present. Gingivitis and periodontitis are present. Gum recession is present."
  },
  {
    value: "3",
    label:
      "Dental score 3 - The teeth show evidence of wear, and calculus accumulation is significant. Several teeth are very loose. There is significant loss of some teeth. Gingivitis and periodontitis are severe. Gum recession is present and tooth root exposure is noted."
  }
];

export const PHYSICAL_STATUS_OPTIONS = [
  {
    value: PatientPhysicalStatus.Normal,
    label: "I. Normal, healthy patient."
  },
  {
    value: PatientPhysicalStatus.Mild,
    label: "II. Mild systemic disease."
  },
  {
    value: PatientPhysicalStatus.Moderate,
    label: "III. Moderate systemic disease."
  },
  {
    value: PatientPhysicalStatus.Severe,
    label: "IV. Severe, life-threatening disease."
  },
  {
    value: PatientPhysicalStatus.Moribund,
    label: "V. Moribund, not expected to live."
  },
  {
    value: PatientPhysicalStatus.Emergency,
    label: "E. Emergency"
  }
];

export const CAT_BODY_SCORE_CONDITIONS = [
  {
    value: 1,
    label:
      "1: Ribs visible on short-haired cats; no palpable fat; severe abdominal tuck; lumbar vertebrae and wings of ilia obvious and easily palpable."
  },
  {
    value: 2,
    label:
      "2: Ribs visible on short- haired cats; no palpable fat; severe abdominal tuck; lumbar vertebrae and wings of ilia obvious and easily palpable."
  },
  {
    value: 3,
    label:
      "3: Ribs easily palpable with minimal fat covering; lumbar vertebrae obvious; obvious waist behind ribs; minimal abdominal fat."
  },
  {
    value: 4,
    label:
      "4: Ribs easily palpable with minimal fat covering; lumbar vertebrae obvious; obvious waist behind ribs; minimal abdominal fat."
  },
  {
    value: 5,
    label:
      "5: Well proportioned; waist observed behind ribs; ribs palpable with slight fat covering; abdominal fat pad minimal."
  },
  {
    value: 6,
    label:
      "6: Well proportioned; waist observed behind ribs; ribs palpable with slight fat covering; abdominal fat pad minimal."
  },
  {
    value: 7,
    label:
      "7: Ribs not easily palpable with moderate fat covering; waist poorly distensible; obvious rounding of abdomen; moderate abdominal fat pad."
  },
  {
    value: 8,
    label:
      "8: Ribs not easily palpable with moderate fat covering; waist poorly distensible; obvious rounding of abdomen; moderate abdominal fat pad."
  },
  {
    value: 9,
    label:
      "9: Ribs not palpable under heavy fat cover; heavy fat deposits over lumbar area, face and limbs; distention of abdomen with no waist; extensive abdominal fat pad."
  }
];

export const DOG_BODY_SCORE_CONDITIONS = [
  {
    value: 1,
    label:
      "1: Ribs, lumbar vertebrae, pelvic bones and all bony prominences evident from a distance. No discernible body fat. Obvious loss of muscle mass."
  },
  {
    value: 2,
    label:
      "2: Ribs, lumbar vertebrae and pelvic bones easily visible. No palpable fat. Some evidence of other bony prominence. Minimal loss of muscle mass."
  },
  {
    value: 3,
    label:
      "3: Ribs easily palpated and may be visible with no palpable fat. Tops of lumbar vertebrae visible. Pelvic bones becoming prominent. Obvious waist."
  },
  {
    value: 4,
    label:
      "4: Ribs easily palpable, with minimal fat covering. Waist easily noted, viewed from above. Abdominal tuck evident."
  },
  {
    value: 5,
    label:
      "5: Ribs palpable without excess fat covering. Waist observed behind ribs when viewed from above. Abdomen tucked up when viewed."
  },
  {
    value: 6,
    label:
      "6: Ribs palpable with slight excess fat covering. Waist is discernible viewed from above but is not prominent. Abdominal tuck apparent."
  },
  {
    value: 7,
    label:
      "7: Ribs palpable with difficulty; heavy fat cover. Noticeable fat deposits over lumbar area and base of tail. Waist absent or barely visible. Abdominal tuck may be present."
  },
  {
    value: 8,
    label:
      "8: Ribs not palpable under very heavy fat cover, or palpable only with significant pressure. Heavy fat deposits over lumbar area and base of tail. Waist absent. No abdominal tuck. Obvious abdominal distension may be present."
  },
  {
    value: 9,
    label:
      "9: Massive fat deposits over thorax, spine and base of tail. Waist and abdominal tuck absent. Fat deposits on neck and limbs. Obvious abdominal distention."
  }
];
